<template>
  <div class="mt-3">
    <div class="header-purple">
      <div>
        <p class="mb-0">
          <strong>
            บันทึกเพิ่มเติม
            <b-button
              v-if="collapseHeader"
              variant="link"
              size="sm"
              class="btn-collapse mb-1"
              @click="collapseHeader = false"
            >
              <b-icon icon="chevron-down"></b-icon>
            </b-button>
            <b-button
              v-if="!collapseHeader"
              variant="link"
              size="sm"
              class="btn-collapse  mb-1"
              @click="collapseHeader = true"
            >
              <b-icon icon="chevron-up"></b-icon>
            </b-button>
          </strong>
          <span class="float-right add-note" @click="openModal"
            >+ <span class="text-add-note">เพิ่มบันทึก</span></span
          >
        </p>
      </div>
    </div>
    <b-collapse v-model="collapseHeader" class="collapse-header">
      <div class="bg-white">
        <b-container class="p-0">
          <b-table
            responsive
            :thead-tr-class="thTableProduct"
            :tbody-tr-class="trTableProduct"
            class="text-center"
            :fields="fields"
            :items="note"
            :busy="isBusy"
            show-empty
            empty-text="ไม่พบข้อมูล"
          >
            <template v-slot:head(statusLogDateTime)="">
              <div class="border-right">
                <strong>วันที่ และ เวลา</strong>
              </div> </template
            ><template v-slot:head(description)="">
              <div class="border-right">
                <strong>รายละเอียด</strong>
              </div> </template
            ><template v-slot:head(statusLog)="">
              <div class="border-right">
                <strong>สถานะ</strong>
              </div>
            </template>
            <template v-slot:cell(statusLogDateTime)="data">
              <div v-if="data.item.statusLogDateTime">
                <span class="m-0"
                  >{{
                    new Date(data.item.statusLogDateTime) | moment($formatDate)
                  }}
                </span>
                <span class="text-gray">
                  ({{
                    new Date(data.item.statusLogDateTime) | moment($formatTime)
                  }})
                </span>
              </div>
              <div v-else><p class="m-0">-</p></div>
            </template>
            <template v-slot:cell(description)="data">
              <div v-if="data.item.description">
                <p class="m-0">{{ data.item.description }}</p>
              </div>
              <div v-else><p class="m-0">-</p></div>
            </template>
            <template v-slot:cell(statusLog)="data">
              <div v-if="data.item.statusLog">
                <p class="m-0">{{ data.item.statusLog }}</p>
              </div>
              <div v-else><p class="m-0">-</p></div>
            </template>
            <template v-slot:cell(statusLogBy)="data">
              <div v-if="data.item.statusLogBy">
                <p class="m-0">{{ data.item.statusLogBy }}</p>
              </div>
              <div v-else><p class="m-0">-</p></div>
            </template>
            <template slot="bottom-row">
              <td class="last-row"></td>
              <td class="last-row"></td>
              <td class="last-row"></td>
              <td class="last-row"></td>
            </template>
          </b-table>
        </b-container>
      </div>
    </b-collapse>
    <b-modal
      v-model="isNoteModalShow"
      size="lg"
      header-class="header-tax"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
    >
      <template #modal-header>
        <div class="w-100">
          <strong class="title-modal">เพิ่มบันทึก</strong>
          <b-icon
            icon="x-circle-fill"
            class="float-right pointer"
            @click="closeModal"
          ></b-icon>
        </div>
      </template>
      <div class="px-4">
        <InputTextArea
          textFloat="รายละเอียด"
          placeholder="ข้อความ"
          v-model="form.note"
          :rows="4"
          isRequired
          type="text"
          :isValidate="$v.form.note.$error"
          :v="$v.form.note"
        />
        <div class="w-100">
          <b-button class="float-left gray-btn" @click="closeModal">
            ยกเลิก
          </b-button>
          <b-button class="float-right purple-btn" @click="checkForm">
            บันทึก
          </b-button>
        </div>
      </div>
    </b-modal>
    <ModalLoading ref="modalLoading" :hasClose="false" />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
  </div>
</template>

<script>
import InputTextArea from "@/components/inputs/InputTextArea";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import { BIcon } from "bootstrap-vue";
import { required } from "vuelidate/lib/validators";
export default {
  name: "Note",
  components: { InputTextArea, ModalLoading, ModalAlertError, BIcon },
  props: {
    id: {
      type: String | Number,
      isRequired: true,
    },
    note: {
      type: Array,
      isRequired: true,
    },
  },
  data() {
    return {
      collapseHeader: true,
      isNoteModalShow: false,
      modalMessage: "",
      form: {
        orderId: this.id,
        note: "",
      },
      fields: [
        {
          key: "statusLogDateTime",
          label: `วันที่ และ เวลา`,
          class: "w-50px text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
          },
        },
        {
          key: "description",
          label: `รายละเอียด`,
          class: "w-50px text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
          },
        },
        {
          key: "statusLog",
          label: `สถานะ`,
          class: "w-100px text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
          },
        },
        {
          key: "statusLogBy",
          label: `โดย`,
          class: "w-100px text-nowrap",
          thStyle: {
            "padding-left": "0px !important",
            "padding-right": "0px !important",
          },
        },
      ],
      thTableProduct: {
        "border-bottom": "2px solid #f8f8f8 !important",
        "min-height": "80px !important",
      },
      trTableProduct: { "border-bottom": "2px solid #f8f8f8 !important" },
      isBusy: false,
    };
  },
  validations: {
    form: {
      note: { required },
    },
  },
  methods: {
    openModal() {
      this.form.note = "";
      this.isNoteModalShow = true;
    },
    closeModal() {
      this.isNoteModalShow = false;
    },
    checkForm() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      } else {
        this.submitForm();
      }
    },
    submitForm() {
      this.$refs.modalLoading.show();
      this.axios
        .post(`${this.$baseUrl}/transaction/note`, this.form)
        .then((data) => {
          this.$refs.modalLoading.hide();
          if (data.result == 1) {
            this.closeModal();
            this.$emit("onSubmitNote", null);
          } else {
            this.modalMessage = data.message;
            this.$refs.modalAlertError.show();
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-collapse {
  color: #333333;
}
.text-gray {
  color: #bcbcbc;
}
.last-row {
  height: 47.4px;
  border-top: 2px solid white;
}
.add-note {
  color: #8f20c6;
  font-size: 16px;
  cursor: pointer;
}
.text-add-note {
  text-decoration: underline;
}
.text-title {
  color: #404040;
}
.purple-btn {
  background-color: #8a44c3;
  color: #ffffff;
}
.gray-btn {
  background-color: #575757;
  color: #ffffff;
}
/deep/ .header-tax {
  background: #eae2f3;
}
</style>
